var isNil = function isNil(value) {
  return value === null || value === undefined;
};
var isNotNil = function isNotNil(value) {
  return !isNil(value);
};
var getNotNil = function getNotNil(value) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "unknown";
  if (isNotNil(value)) {
    return value;
  }
  throw new Error("Value \"".concat(name, "\" is nil."));
};
export { isNil, isNotNil, getNotNil };